// The glyphs the registration screens draw, verbatim from the prototype's
// markup (customer-sign-in-registration, flows 1.3/1.4/1.6). Kept beside the
// customer screens rather than added to the desk's Icon set: these are the
// customer app's own, and the desk's set is "carried verbatim from
// _prototype/components.jsx" — a different prototype.

interface GlyphProps {
  size?: number;
  className?: string;
  strokeWidth?: number;
}

function Stroke({ size = 16, className, strokeWidth = 2, children }: GlyphProps & { children: React.ReactNode }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}

export const G = {
  back: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <path d="m12 19-7-7 7-7M19 12H5" />
    </Stroke>
  ),
  user: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </Stroke>
  ),
  users: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
    </Stroke>
  ),
  phone: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
    </Stroke>
  ),
  lock: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <rect x="3" y="11" width="18" height="11" rx="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </Stroke>
  ),
  pin: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
      <circle cx="12" cy="10" r="3" />
    </Stroke>
  ),
  paw: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <circle cx="11" cy="4" r="2" />
      <circle cx="18" cy="8" r="2" />
      <circle cx="20" cy="16" r="2" />
      <path d="M9 10a5 5 0 0 1 5 5v3.5a3.5 3.5 0 0 1-6.84 1.045Q6.52 17.48 4.46 16.84A3.5 3.5 0 0 1 5.5 10Z" />
    </Stroke>
  ),
  breed: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <circle cx="12" cy="8" r="6" />
      <path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11" />
    </Stroke>
  ),
  pill: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <path d="m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z" />
      <path d="m8.5 8.5 7 7" />
    </Stroke>
  ),
  dogs: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <circle cx="6" cy="7" r="1.6" />
      <circle cx="10.4" cy="5.6" r="1.6" />
      <path d="M5.2 10.2a3.2 3.2 0 0 1 3.2 3.2v1.9a2.1 2.1 0 0 1-4.05.62A6 6 0 0 0 3 14.6a2.1 2.1 0 0 1 .6-4.4Z" />
      <circle cx="17.6" cy="12" r="1.4" />
      <circle cx="21" cy="10.9" r="1.4" />
      <path d="M17 14.6a2.7 2.7 0 0 1 2.7 2.7v1.6a1.8 1.8 0 0 1-3.5.5 5 5 0 0 0-1.3-.9 1.8 1.8 0 0 1 .5-3.8Z" />
    </Stroke>
  ),
  clipboard: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <rect width="8" height="4" x="8" y="2" rx="1" />
      <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
      <path d="M12 11h4" />
      <path d="M12 16h4" />
      <path d="M8 11h.01" />
      <path d="M8 16h.01" />
    </Stroke>
  ),
  syringe: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <path d="m18 2 4 4" />
      <path d="m17 7 3-3" />
      <path d="M19 9 8.7 19.3a2.4 2.4 0 0 1-3.4 0l-.6-.6a2.4 2.4 0 0 1 0-3.4L15 5" />
      <path d="m9 11 4 4" />
      <path d="m5 19-3 3" />
      <path d="m14 4 6 6" />
    </Stroke>
  ),
  chevron: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <path d="m6 9 6 6 6-6" />
    </Stroke>
  ),
  camera: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z" />
      <circle cx="12" cy="13" r="3" />
    </Stroke>
  ),
  warn: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
      <path d="M12 9v4M12 17h.01" />
    </Stroke>
  ),
  tick: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <path d="M20 6 9 17l-5-5" />
    </Stroke>
  ),
  cross: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <path d="M18 6 6 18M6 6l12 12" />
    </Stroke>
  ),
  calendar: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <path d="M16 2v4M8 2v4M3 10h18" />
    </Stroke>
  ),
  home: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <path d="M9 22V12h6v10" />
    </Stroke>
  ),
  sunrise: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2m-7.07-15.07 1.41 1.41m11.32 11.32 1.41 1.41M2 12h2m16 0h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" />
    </Stroke>
  ),
  sunset: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <path d="M12 10V2m-7.07 8.93 1.41 1.41M2 18h2m16 0h2m-2.93-7.07-1.41 1.41M22 22H2m14-16-4 4-4-4m8 12a4 4 0 0 0-8 0" />
    </Stroke>
  ),
  signOut: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <path d="m16 17 5-5-5-5" />
      <path d="M21 12H9" />
    </Stroke>
  ),
  person: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </Stroke>
  ),
  logIn: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
      <path d="m10 17 5-5-5-5" />
      <path d="M15 12H3" />
    </Stroke>
  ),
  // request-a-stay (flows 2.1, 2.2), verbatim from the prototype's markup.
  flag: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <path d="M4 22V4a1 1 0 0 1 .4-.8A6 6 0 0 1 8 2c3 0 5 2 7.333 2q2 0 3.067-.8A1 1 0 0 1 20 4v10a1 1 0 0 1-.4.8A6 6 0 0 1 16 16c-3 0-5-2-7.333-2A6 6 0 0 0 4 15" />
    </Stroke>
  ),
  chevLeft: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <path d="m15 18-6-6 6-6" />
    </Stroke>
  ),
  chevRight: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <path d="m9 18 6-6-6-6" />
    </Stroke>
  ),
  arrowRight: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <path d="M5 12h14m-7-7 7 7-7 7" />
    </Stroke>
  ),
  // c28's own (Freddi, 2026-10-08: "same icons on booking requested page as
  // prototype"), verbatim from the prototype's markup.
  waiting: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 6.8V12l3.6 2.1" />
    </Stroke>
  ),
  sun: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2m-7.07-15.07 1.41 1.41m11.32 11.32 1.41 1.41M2 12h2m16 0h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" />
    </Stroke>
  ),
  euro: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <path d="M4 10h12M4 14h9M19 6a7.7 7.7 0 0 0-5.2-2A7.9 7.9 0 0 0 6 12c0 4.4 3.5 8 7.8 8 2 0 3.8-.8 5.2-2" />
    </Stroke>
  ),
  clipboardCheck: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <rect width="8" height="4" x="8" y="2" rx="1" ry="1" />
      <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
      <path d="m9 14 2 2 4-4" />
    </Stroke>
  ),
  thumbsUp: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <path d="M7 10v12" />
      <path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z" />
    </Stroke>
  ),
  calendarCheck: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <path d="M16 2v4M8 2v4M3 10h18" />
      <path d="m9 16 2 2 4-4" />
    </Stroke>
  ),
  clock: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <circle cx="12" cy="12" r="10" />
      <path d="M12 6v6l4 2" />
    </Stroke>
  ),
  ban: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <circle cx="12" cy="12" r="10" />
      <path d="m4.9 4.9 14.2 14.2" />
    </Stroke>
  ),
  info: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <circle cx="12" cy="12" r="10" />
      <path d="M12 16v-4M12 8h.01" />
    </Stroke>
  ),
  shield: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
    </Stroke>
  ),
  noSignal: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <path d="M12 20h.01M8.5 16.43a5 5 0 0 1 7 0M2 8.82a15 15 0 0 1 4.17-2.65M10.66 5c4.01-.36 8.14.9 11.34 3.76M16.85 11.25a10 10 0 0 1 2.22 1.68M5 13a10 10 0 0 1 5.24-2.76M2 2l20 20" />
    </Stroke>
  ),
  bubble: (p: GlyphProps = {}) => (
    <Stroke {...p}>
      <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
    </Stroke>
  ),
};

/** The provider marks the pick row draws beside *Signed in ·* (AC9). */
export function ProviderMark({ provider }: { provider: 'google' | 'microsoft' | 'apple' }) {
  const title = `Signed in with ${provider === 'google' ? 'Google' : provider === 'microsoft' ? 'Microsoft' : 'Apple'}`;
  if (provider === 'google') {
    return (
      <svg className="cp-provider" width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
        <title>{title}</title>
        <path fill="#4285F4" d="M21.8 12.2c0-.7-.1-1.4-.2-2H12v3.9h5.5c-.2 1.3-1 2.3-2 3v2.5h3.3c1.9-1.8 3-4.4 3-7.4z" />
        <path fill="#34A853" d="M12 21.6c2.7 0 5-.9 6.6-2.4l-3.3-2.5c-.9.6-2 1-3.3 1-2.6 0-4.8-1.7-5.5-4.1H3.1v2.6c1.7 3.2 5 5.4 8.9 5.4z" />
        <path fill="#FBBC05" d="M6.5 13.6c-.2-.6-.3-1.2-.3-1.8s.1-1.2.3-1.8V7.4H3.1C2.4 8.8 2 10.3 2 12s.4 3.2 1.1 4.6l3.4-2.6z" />
        <path fill="#EA4335" d="M12 6.3c1.5 0 2.8.5 3.8 1.5l2.9-2.9C17 3.3 14.7 2.4 12 2.4c-3.9 0-7.2 2.2-8.9 5.4l3.4 2.6c.7-2.4 2.9-4.1 5.5-4.1z" />
      </svg>
    );
  }
  if (provider === 'microsoft') {
    return (
      <svg className="cp-provider" width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
        <title>{title}</title>
        <rect x="3" y="3" width="8.5" height="8.5" fill="#F25022" />
        <rect x="12.5" y="3" width="8.5" height="8.5" fill="#7FBA00" />
        <rect x="3" y="12.5" width="8.5" height="8.5" fill="#00A4EF" />
        <rect x="12.5" y="12.5" width="8.5" height="8.5" fill="#FFB900" />
      </svg>
    );
  }
  return (
    <svg className="cp-provider" width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
      <title>{title}</title>
      <path d="M16.4 12.9c0-2.4 2-3.6 2.1-3.7-1.1-1.7-2.9-1.9-3.5-1.9-1.5-.2-2.9.9-3.7.9-.8 0-1.9-.9-3.2-.8-1.6 0-3.1 1-4 2.4-1.7 3-.4 7.3 1.2 9.7.8 1.2 1.8 2.5 3.1 2.4 1.2 0 1.7-.8 3.2-.8s1.9.8 3.2.8 2.2-1.2 3-2.4c.9-1.4 1.3-2.7 1.4-2.8-.1 0-2.8-1-2.8-3.8zM14 5.7c.7-.8 1.1-1.9 1-3-1 0-2.1.7-2.8 1.5-.6.7-1.2 1.8-1 2.9 1.1.1 2.2-.6 2.8-1.4z" />
    </svg>
  );
}
